module.exports = __webpack_public_path__ + "static/predicticon-417387fa7d448470e9a4a418dbb43253.jpeg";